'use client';

import PageType from '@alltrails/amplitude/enums/PageType';
import { LOCATION_SECTION_ID_TOP_MODULES } from '@/constants/locationSectionIds';
import { LocationDetailsApiResponse } from '@/types/locationDetailsPages/shared';
import { SubLocationDetailsApiResponse } from '@/types/subLocationListPages/shared';
import PageSection from '../layouts/PageSection';
import TopModuleSection from './TopModuleSection';

type Props = {
  details: LocationDetailsApiResponse | SubLocationDetailsApiResponse;
  pageType?: PageType;
};

const TopModule = ({ details, pageType }: Props) => {
  const locationType = details.locationType;
  const topModules = details?.rivers;

  if (!topModules || !topModules.length) {
    return null;
  }

  return (
    <>
      {topModules?.map?.((topModule, index) => {
        if (!topModule.items.length) {
          return null;
        }
        const locationNameForParkPage = locationType === 'park' ? (details.cityName ?? details.stateName ?? details.countryName) : undefined;

        return (
          <PageSection key={topModule.type} hideXOverflow>
            <TopModuleSection
              id={details.id}
              locationName={locationNameForParkPage}
              locationType={locationType}
              pageType={pageType}
              sectionId={index === 0 ? LOCATION_SECTION_ID_TOP_MODULES : undefined}
              topModule={topModule}
            />
          </PageSection>
        );
      })}
    </>
  );
};

export default TopModule;
